import React, { useRef } from 'react';
import { useIntl } from 'umi';
// import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import VisualisSegment from '../VisualisSegment';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import useBarCharts from '@/pages/intelligence/pages/StoreRanks/components/StoreRankMoreCore/hooks/useStoreRankMoreCoreBarChart';
import { TOP_CHARTS_TYPES } from '@/pages/intelligence/components/ChartBubble';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';

import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';
import type { IStoreRankMoreCoreRankPrimaryKey } from '@/pages/intelligence/types/storeRank';

interface IStoreRankMoreCoreVisualisProps extends IBaseProps {
  entityType: IGameType;
  chartType: ChartType;
  isLoading: boolean;
  isNoData: boolean;
  isShowSortInfo?: boolean;
  dateType: 'Month' | (string & {});
  sortKeyName: any;
  order: 'asc' | 'desc' | (string & {});
  seriesData: any;
  xAxisData: any;
  // tooltipFormatter: any;
  createLegendsCustomMade: any;
  yAxisFormatter: any;
  currentLine: any;
  setSegment: any;
  segments: any[];
  titleNow: string;
  imageKey: string;
  primaryKey: IStoreRankMoreCoreRankPrimaryKey;
  sectionalRankKeys: string[];
  tableSelection: any[];
  tooltipCfg?: {
    headerLeftTitle?: string;
    headerRightTitle?: string;
  };
}

// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const StoreRankMoreCoreVisualis: React.FC<IStoreRankMoreCoreVisualisProps> = (props) => {
  const {
    entityType,
    chartType = ChartType.Bar,
    isLoading,
    isNoData,
    isShowSortInfo = false,
    dateType = 'Month',
    sortKeyName,
    seriesData,
    order,
    xAxisData,
    // tooltipFormatter,
    createLegendsCustomMade,
    yAxisFormatter,
    currentLine,
    setSegment,
    titleNow,
    segments,
    segment,
    imageKey,
    primaryKey,
    sectionalRankKeys,
    tableSelection,
    tooltipCfg,
  } = props;

  // console.debug('StoreRankMoreCoreVisualis', props)

  const { headerLeftTitle, headerRightTitle } = tooltipCfg || {};

  const { formatMessage } = useIntl();

  const cardRef = useRef(null);

  // 柱状图
  const { option: barOption } = useBarCharts({
    imageKey,
    imageType: entityType,
    primaryKey,
    tooltipCfg: {
      headerLeftTitle: headerLeftTitle || '',
      headerRightTitle: headerRightTitle || formatMessage({ id: 'dbi_count' }),
    },
    dimensions: sectionalRankKeys,
    data: tableSelection,
  });

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineXAxisData: xAxisData, // x轴 label 数据
    lineSeriesData: seriesData, // 折线 数据
    legendsCustomMade: createLegendsCustomMade, // 图例
    yAxisFormatter, // y轴格式化函数
    // tooltipFormatter,// 悬浮窗轴格式化函数
    dateType,
    topChartsType: TOP_CHARTS_TYPES.STORE_RANK_MORE_LINE,
    entityType,
    titleNow,
    gridConfig: {
      left: 33,
      right: 40,
      top: 10,
      bottom: 34,
    },
  });

  const handleMetricChange = (value: string): void => {
    setSegment(value);
    currentLine(value);
  };

  return (
    <>
      {segments?.length > 1 && (
        <div className="card-flex">
          <div className="card-title">
            <VisualisSegment
              iconable={true}
              options={segments}
              value={segment}
              onChange={handleMetricChange}
            />
          </div>
        </div>
      )}

      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={isLoading}
          isNodata={isNoData}
          chartType={chartType}
          barOption={barOption}
          // 排名 y 轴语义上仅显示整数 rank：minInterval: 1 防止 echarts 在数据范围较小（如 [1, 2]、[1, 3]）时
          // 自动产出 0.2/0.5 等小数 tick 被 yAxisFormatter 取整后出现重复 label
          lineOption={{ ...lineOption, yAxis: { ...lineOption.yAxis, inverse: true, min: 1, minInterval: 1 } }}
        />
      </div>
    </>
  );
};

export default StoreRankMoreCoreVisualis;
